import React from "react";
import { Box } from "@mui/material";
import Field from "../shared/Field";

const FormHero = ({ data, onChange }) => (
  <Box>
    <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
      <Field
        label="Headline Line 1"
        value={data.headlineLine1}
        onChange={(v) => onChange({ ...data, headlineLine1: v })}
        placeholder="We Build Your"
      />
      <Field
        label="Headline Line 2 (orange)"
        value={data.headlineLine2}
        onChange={(v) => onChange({ ...data, headlineLine2: v })}
        placeholder="MERN Stack Success"
      />
    </Box>
    <Field
      label="Subheadline"
      value={data.subheadline}
      onChange={(v) => onChange({ ...data, subheadline: v })}
      multiline
      placeholder="We design and develop high-performance full-stack applications..."
    />
    <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
      <Field
        label="Primary CTA"
        value={data.primaryCta}
        onChange={(v) => onChange({ ...data, primaryCta: v })}
        placeholder="View Projects →"
      />
      <Field
        label="Secondary CTA"
        value={data.secondaryCta}
        onChange={(v) => onChange({ ...data, secondaryCta: v })}
        placeholder="Book Free Consultation"
      />
    </Box>
  </Box>
);

export default FormHero;
